<template>
  <div class="game">
    <div v-if="!isSingleGameMode" class="tools">
      <div class="top">
        <a
          class="tool-item tool-fullscreen icon"
          @click="toggleFullScreen"
          title="전체화면"
        >
          <template v-if="!enabledToggleFullscreen">
            <svg version="1.1" viewBox="0 0 128 128">
              <path
                d="M52.585,65.916c-0.556,-0.555 -1.195,-0.833 -1.917,-0.833c-0.722,0 -1.362,0.277 -1.917,0.833l-27.667,27.667l-12,-12.002c-1.055,-1.053 -2.304,-1.582 -3.75,-1.582c-1.445,0 -2.695,0.529 -3.751,1.582c-1.055,1.057 -1.583,2.308 -1.583,3.752l0,37.334c0,1.445 0.528,2.694 1.583,3.75c1.057,1.055 2.307,1.583 3.751,1.583l37.334,0c1.445,0 2.694,-0.528 3.75,-1.583c1.055,-1.056 1.583,-2.305 1.583,-3.75c0,-1.444 -0.528,-2.695 -1.583,-3.752l-12,-11.997l27.667,-27.669c0.555,-0.555 0.833,-1.193 0.833,-1.916c0,-0.723 -0.278,-1.36 -0.833,-1.918l-9.5,-9.499Z"
                style="fill-rule:nonzero;"
              />
              <path
                d="M126.418,1.583c-1.055,-1.056 -2.305,-1.583 -3.75,-1.583l-37.334,0c-1.444,0 -2.693,0.527 -3.75,1.583c-1.054,1.055 -1.582,2.305 -1.582,3.75c0,1.445 0.528,2.695 1.582,3.75l11.999,12l-27.667,27.667c-0.555,0.556 -0.833,1.194 -0.833,1.917c0,0.722 0.278,1.361 0.833,1.916l9.502,9.501c0.555,0.555 1.192,0.832 1.915,0.832c0.723,0 1.361,-0.277 1.916,-0.832l27.669,-27.667l11.997,11.999c1.057,1.055 2.308,1.584 3.752,1.584c1.445,0 2.694,-0.529 3.75,-1.584c1.055,-1.055 1.582,-2.305 1.582,-3.75l0,-37.334c0.001,-1.446 -0.523,-2.693 -1.581,-3.749Z"
                style="fill-rule:nonzero;"
              />
            </svg>
          </template>
          <template v-else>
            <svg version="1.1" viewBox="0 0 128 128">
              <path
                d="M128,12.463c0,-0.735 -0.284,-1.384 -0.848,-1.95l-9.665,-9.664c-0.565,-0.565 -1.213,-0.848 -1.949,-0.848c-0.735,0 -1.383,0.283 -1.948,0.848l-28.146,28.143l-12.204,-12.206c-1.073,-1.074 -2.347,-1.611 -3.816,-1.611c-1.468,0 -2.74,0.537 -3.814,1.611c-1.073,1.074 -1.61,2.345 -1.61,3.814l0,37.976c0,1.47 0.537,2.741 1.61,3.815c1.074,1.074 2.345,1.611 3.814,1.611l37.975,0c1.47,0 2.744,-0.537 3.817,-1.611c1.072,-1.074 1.611,-2.345 1.611,-3.815c0,-1.469 -0.538,-2.741 -1.611,-3.814l-12.207,-12.207l28.144,-28.143c0.563,-0.564 0.847,-1.214 0.847,-1.949Z"
                style="fill-rule:nonzero;"
              />
              <path
                d="M58.574,64.003l-37.975,0c-1.469,0 -2.741,0.537 -3.815,1.611c-1.073,1.072 -1.611,2.345 -1.611,3.814c0,1.469 0.538,2.741 1.611,3.814l12.207,12.207l-28.143,28.142c-0.566,0.565 -0.848,1.216 -0.848,1.949c0,0.736 0.282,1.386 0.848,1.951l9.662,9.663c0.566,0.564 1.216,0.845 1.95,0.845c0.735,0 1.385,-0.28 1.95,-0.845l28.143,-28.144l12.206,12.206c1.073,1.073 2.345,1.611 3.814,1.611c1.47,0 2.742,-0.538 3.815,-1.611c1.074,-1.072 1.611,-2.345 1.611,-3.815l0,-37.975c0,-1.469 -0.537,-2.741 -1.61,-3.812c-1.073,-1.074 -2.345,-1.611 -3.815,-1.611Z"
                style="fill-rule:nonzero;"
              />
            </svg>
          </template>
        </a>
        <a
          v-if="!isSingleGameMode"
          class="tool-item tool-home icon"
          @click="gotoHome"
          title="홈으로 이동"
        >
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M3 10v11h6v-7h6v7h6v-11L12,3z" />
          </svg>
        </a>
        <a
          class="tool-item tool-save icon"
          @click="downloadSaveFile"
          title="세이브 파일 저장하기"
        >
          <svg version="1.1" viewBox="0 0 128 128">
            <path
              d="M126.333,35.332c-1.111,-2.665 -2.445,-4.777 -4.001,-6.332l-23.333,-23.334c-1.555,-1.554 -3.666,-2.888 -6.333,-4c-2.665,-1.111 -5.11,-1.666 -7.332,-1.666l-77.334,0c-2.221,0 -4.111,0.777 -5.666,2.333c-1.556,1.555 -2.333,3.444 -2.333,5.667l0,112c0,2.224 0.777,4.113 2.333,5.668c1.555,1.554 3.445,2.332 5.666,2.332l112.001,0c2.223,0 4.112,-0.778 5.667,-2.332c1.554,-1.555 2.331,-3.444 2.331,-5.668l0,-77.333c0,-2.223 -0.555,-4.667 -1.666,-7.335Zm-72.999,-22c0,-0.722 0.264,-1.346 0.792,-1.874c0.528,-0.527 1.153,-0.791 1.875,-0.791l16.001,0c0.72,0 1.345,0.263 1.873,0.791c0.529,0.528 0.793,1.152 0.793,1.874l0,26.667c0,0.724 -0.266,1.348 -0.793,1.876c-0.528,0.526 -1.153,0.791 -1.873,0.791l-16.001,0c-0.722,0 -1.348,-0.264 -1.875,-0.791c-0.528,-0.529 -0.792,-1.152 -0.792,-1.876l0,-26.667Zm42.668,104.002l-64.002,0l0,-32.001l64.002,0l0,32.001Zm21.334,0l-10.67,0l0,-34.668c0,-2.223 -0.778,-4.111 -2.333,-5.667c-1.555,-1.555 -3.444,-2.333 -5.665,-2.333l-69.334,0c-2.223,0 -4.112,0.778 -5.668,2.333c-1.555,1.555 -2.333,3.444 -2.333,5.667l0,34.668l-10.666,0l0,-106.668l10.666,0l0,34.667c0,2.223 0.777,4.111 2.333,5.667c1.556,1.555 3.445,2.333 5.667,2.333l48.002,0c2.221,0 4.112,-0.778 5.666,-2.333c1.554,-1.555 2.333,-3.444 2.333,-5.667l0,-34.667c0.833,0 1.915,0.277 3.25,0.833c1.335,0.555 2.279,1.11 2.834,1.666l23.418,23.417c0.556,0.556 1.111,1.515 1.666,2.876c0.558,1.361 0.834,2.431 0.834,3.209l0,74.667Z"
            />
          </svg>
        </a>
        <a
          class="tool-item tool-load icon"
          @click="uploadSaveFile"
          title="세이브 파일 불러오기"
        >
          <svg version="1.1" viewBox="0 0 128 128">
            <path
              d="M126.994,66.077c-0.982,-2.056 -2.482,-3.632 -4.491,-4.726c-2.012,-1.095 -4.224,-1.642 -6.638,-1.642l-12.874,0l0,-10.729c0,-4.112 -1.476,-7.644 -4.426,-10.594c-2.951,-2.951 -6.482,-4.425 -10.594,-4.425l-36.476,0l0,-2.146c0,-4.112 -1.475,-7.644 -4.425,-10.593c-2.95,-2.951 -6.482,-4.426 -10.594,-4.426l-21.457,0c-4.112,0 -7.644,1.475 -10.594,4.426c-2.95,2.949 -4.425,6.481 -4.425,10.593l0,64.37c0,4.112 1.475,7.643 4.425,10.593c2.95,2.951 6.482,4.426 10.594,4.426l72.954,0c2.993,0 6.122,-0.771 9.387,-2.314c3.263,-1.541 5.854,-3.498 7.776,-5.867l19.781,-24.339c2.056,-2.592 3.083,-5.273 3.083,-8.046c0.001,-1.61 -0.334,-3.128 -1.006,-4.561Zm-118.411,-34.261c0,-1.787 0.625,-3.307 1.877,-4.559c1.251,-1.251 2.771,-1.877 4.56,-1.877l21.457,0c1.788,0 3.307,0.625 4.559,1.877c1.251,1.252 1.877,2.772 1.877,4.559l0,4.292c0,1.788 0.627,3.308 1.878,4.559c1.251,1.251 2.771,1.878 4.559,1.878l38.621,0c1.788,0 3.309,0.626 4.561,1.877c1.25,1.251 1.876,2.771 1.876,4.559l0,10.729l-51.495,0c-3.039,0 -6.169,0.771 -9.388,2.313c-3.218,1.542 -5.811,3.498 -7.778,5.868l-17.164,21.12l0,-57.195Zm109.628,41.438l-19.713,24.339c-1.116,1.386 -2.704,2.57 -4.761,3.552c-2.056,0.984 -3.978,1.476 -5.766,1.476l-72.952,0c-2.369,0 -3.553,-0.783 -3.553,-2.347c0,-0.715 0.402,-1.609 1.207,-2.683l19.713,-24.339c1.162,-1.386 2.759,-2.559 4.794,-3.52c2.033,-0.961 3.944,-1.442 5.733,-1.442l72.952,0c2.369,0 3.553,0.783 3.553,2.347c0,0.762 -0.401,1.633 -1.207,2.617Z"
            />
          </svg>
        </a>
        <div id="ScreenSize">
          <span style="color:white; font-size:small;"
            >G:<span id="gamewidth"></span> x
            <span id="gameheight"></span></span
          ><br />
          <span style="color:white; font-size:small;"
            >S:<span id="screenwidth"></span> x <span id="screenheight"></span
          ></span>
        </div>
      </div>
      <div class="bottom">
        <a
          class="tool-item tool-keyboard icon"
          :class="{ disabled: !enabledToggleKeyboard }"
          @click="toggleKeyboard"
        >
          <svg version="1.1" viewBox="0 0 128 128">
            <path
              d="M125.5,28.1c-1.667,-1.667 -3.679,-2.501 -6.034,-2.501l-110.933,0c-2.355,0 -4.366,0.834 -6.033,2.501c-1.666,1.667 -2.5,3.678 -2.5,6.033l0,59.733c0,2.356 0.834,4.366 2.5,6.033c1.667,1.667 3.678,2.502 6.033,2.502l110.933,0c2.355,0 4.367,-0.835 6.034,-2.502c1.666,-1.667 2.5,-3.677 2.5,-6.033l0,-59.733c0,-2.355 -0.834,-4.366 -2.5,-6.033Zm-6.034,65.766l-110.933,0l0,-59.733l110.933,0l0,59.733Z"
            />
            <path
              d="M18.133,85.332l6.4,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.71 -0.355,-1.067 -1.067,-1.067l-6.4,0c-0.711,0 -1.067,0.357 -1.067,1.067l0,6.399c0,0.711 0.356,1.067 1.067,1.067Z"
            />
            <path
              d="M18.133,68.267l14.933,0c0.711,0 1.068,-0.357 1.068,-1.068l0,-6.4c0,-0.711 -0.357,-1.066 -1.068,-1.066l-14.933,0c-0.711,0 -1.067,0.355 -1.067,1.066l0,6.4c0,0.711 0.356,1.068 1.067,1.068Z"
            />
            <path
              d="M18.133,51.199l6.4,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.711 -0.355,-1.066 -1.067,-1.067l-6.4,0c-0.711,0 -1.067,0.356 -1.067,1.067l0,6.399c0,0.711 0.356,1.067 1.067,1.067Z"
            />
            <path
              d="M92.801,76.799l-57.6,0c-0.712,0 -1.067,0.357 -1.067,1.068l0,6.399c0,0.709 0.355,1.067 1.067,1.067l57.597,0c0.712,0 1.068,-0.356 1.068,-1.067l0,-6.399c0,-0.711 -0.356,-1.068 -1.065,-1.068Z"
            />
            <path d="M42.667,67.199c0,0.711 0.355,1.068 1.066,1.068l6.4,0c0.711,0 1.066,-0.357 1.066,-1.068l0,-6.4c0,-0.711 -0.354,-1.066 -1.066,-1.066l-6.4,0c-0.711,0 -1.066,0.355 -1.066,1.066l0,6.4Z" />
            <path d="M35.201,51.199l6.399,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.711 -0.356,-1.066 -1.067,-1.067l-6.399,0c-0.712,0 -1.067,0.356 -1.067,1.067l0,6.399c0,0.711 0.356,1.067 1.067,1.067Z" />
            <path d="M59.733,67.199c0,0.711 0.356,1.068 1.066,1.068l6.4,0c0.711,0 1.068,-0.357 1.068,-1.068l0,-6.4c0,-0.711 -0.357,-1.066 -1.068,-1.066l-6.4,0c-0.71,0 -1.066,0.355 -1.066,1.066l0,6.4Z" />
            <path d="M52.266,51.199l6.4,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.711 -0.355,-1.066 -1.067,-1.067l-6.4,0c-0.711,0 -1.067,0.356 -1.067,1.067l0,6.399c0,0.711 0.356,1.067 1.067,1.067Z" />
            <path d="M76.8,67.199c0,0.711 0.356,1.068 1.065,1.068l6.401,0c0.711,0 1.066,-0.357 1.066,-1.068l0,-6.4c0,-0.711 -0.355,-1.066 -1.066,-1.066l-6.401,0c-0.709,0 -1.065,0.355 -1.065,1.066l0,6.4Z" />
            <path d="M109.866,76.799l-6.399,0c-0.712,0 -1.068,0.357 -1.068,1.068l0,6.399c0,0.709 0.356,1.067 1.068,1.067l6.399,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.711 -0.355,-1.068 -1.067,-1.068Z" />
            <path d="M69.333,51.199l6.401,0c0.711,0 1.066,-0.356 1.066,-1.067l0,-6.399c0,-0.711 -0.355,-1.066 -1.066,-1.067l-6.401,0c-0.711,0 -1.066,0.356 -1.066,1.067l0,6.399c0,0.711 0.355,1.067 1.066,1.067Z" />
            <path d="M86.4,51.199l6.399,0c0.711,0 1.067,-0.356 1.067,-1.067l0,-6.399c0,-0.711 -0.356,-1.066 -1.067,-1.067l-6.399,0c-0.711,0 -1.068,0.356 -1.068,1.067l0,6.399c0,0.711 0.357,1.067 1.068,1.067Z" />
            <path d="M93.866,67.199c0,0.711 0.355,1.068 1.066,1.068l14.933,0c0.712,0 1.068,-0.357 1.068,-1.068l0,-23.466c0,-0.711 -0.355,-1.066 -1.068,-1.067l-6.399,0c-0.711,0 -1.067,0.356 -1.067,1.067l0,16l-7.467,0c-0.711,0 -1.066,0.355 -1.066,1.066l0,6.4l0,0Z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- 게임 화면: canvas만 여기에 -->
    <div
      class="screen"
      :style="{
        '--screen-width': `${width}px`,
        '--screen-height': `${height}px`,
      }"
      ref="screen"
    >
      <div class="canvas-container">
        <canvas ref="canvas" style="cursor: none;"></canvas>
      </div>
      <div
        class="event-blocker joystick"
        ref="mobileController"
        @touchstart.stop.prevent
        @touchend.stop.prevent
        @touchmove.stop.prevent
      ></div>
    </div>

    <!-- 키패드: screen 밖 → 게임 화면을 절대 가리지 않음 -->
    <div class="keyboard" v-if="enabledToggleKeyboard">
      <div class="controller-tab-header">
        <button class="tab-btn keyboard-tab" :class="{ active: controllerMode === 'keyboard' }" @touchstart.stop.prevent="selectControllerMode('keyboard')" @mousedown.stop.prevent="selectControllerMode('keyboard')">⌨ Keyboard</button>
        <button class="tab-btn mouse-tab" :class="{ active: controllerMode === 'mouse' }" @touchstart.stop.prevent="selectControllerMode('mouse')" @mousedown.stop.prevent="selectControllerMode('mouse')">🖱 Mouse</button>
      </div>

      <template v-if="controllerMode === 'mouse'">
        <div class="mouse-pad">
          <!-- 속도 조절 슬라이더 -->
          <div class="speed-row">
            <span class="speed-label">🐢 속도</span>
            <input class="speed-slider" type="range" min="2" max="30" v-model.number="mouseSpeed" />
            <span class="speed-label">🐇</span>
          </div>
          <!-- D-Pad 방향 버튼 -->
          <!-- D-Pad 방향 버튼 -->
          <div class="dpad-container" @touchstart.prevent="onDpadTouchStart" @touchmove.prevent="onDpadTouchMove" @touchend.prevent="onDpadTouchEnd">
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'upleft' }">↖</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'up' }">▲</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'upright' }">↗</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'left' }">◀</div>
            <div class="dpad-btn dpad-center" @touchstart.stop.prevent="onMouseLeftDown" @touchend.stop.prevent="onMouseLeftUp">좌클릭</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'right' }">▶</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'downleft' }">↙</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'down' }">▼</div>
            <div class="dpad-btn" :class="{ pressing: activeDpadDir === 'downright' }">↘</div>
          </div>
          <!-- 클릭 버튼 -->
          <div class="mouse-buttons-col">
            <div class="line">
              <button class="game-btn click-btn right-click-btn" style="width: 100%; flex: 1;" @touchstart="onMouseRightDown" @touchend="onMouseRightUp">우클릭</button>
            </div>
            <div class="line pad-keys">
              <Key label="ESC" @keydown="keydown('Escape')" @keyup="keyup('Escape')" />
              <Key label="Space" @keydown="keydown('Space')" @keyup="keyup('Space')" />
              <Key label="Enter" style="flex: 2 !important; max-width: 160px !important;" @keydown="keydown('Enter')" @keyup="keyup('Enter')" />
            </div>
            <div class="line pad-keys font-small">
              <Key label="1" @keydown="keydown('Digit1')" @keyup="keyup('Digit1')" />
              <Key label="2" @keydown="keydown('Digit2')" @keyup="keyup('Digit2')" />
              <Key label="3" @keydown="keydown('Digit3')" @keyup="keyup('Digit3')" />
              <Key label="4" @keydown="keydown('Digit4')" @keyup="keyup('Digit4')" />
              <Key label="5" @keydown="keydown('Digit5')" @keyup="keyup('Digit5')" />
            </div>
            <div class="line pad-keys font-small">
              <Key label="6" @keydown="keydown('Digit6')" @keyup="keyup('Digit6')" />
              <Key label="7" @keydown="keydown('Digit7')" @keyup="keyup('Digit7')" />
              <Key label="8" @keydown="keydown('Digit8')" @keyup="keyup('Digit8')" />
              <Key label="9" @keydown="keydown('Digit9')" @keyup="keyup('Digit9')" />
              <Key label="0" @keydown="keydown('Digit0')" @keyup="keyup('Digit0')" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="keyboard-pad-wrapper">
          <div class="col">
            <div class="line">
              <Key class="key-col-1 key-row-1" label="ESC" @keydown="keydown('Escape')" @keyup="keyup('Escape')" />
              <Key class="key-col-1 key-row-1" label="Arrow<br>Up" @keydown="keydown('ArrowUp')" @keyup="keyup('ArrowUp')" />
              <Key class="key-col-1 key-row-1" label="Arrow<br>Down" @keydown="keydown('ArrowDown')" @keyup="keyup('ArrowDown')" />
            </div>
            <div class="line">
              <Key class="key-col-1 key-row-1" label="7" sublabel="↖" @keydown="keydown('Digit7')" @keyup="keyup('Digit7')" />
              <Key class="key-col-1 key-row-1" label="8" sublabel="↑" @keydown="keydown('Digit8')" @keyup="keyup('Digit8')" />
              <Key class="key-col-1 key-row-1" label="9" sublabel="↗" @keydown="keydown('Digit9')" @keyup="keyup('Digit9')" />
            </div>
            <div class="line">
              <Key class="key-col-1 key-row-1" label="4" sublabel="←" @keydown="keydown('Digit4')" @keyup="keyup('Digit4')" />
              <Key class="key-col-1 key-row-1" label="5" sublabel="LClick" @keydown="keydown('Digit5')" @keyup="keyup('Digit5')" />
              <Key class="key-col-1 key-row-1" label="6" sublabel="→" @keydown="keydown('Digit6')" @keyup="keyup('Digit6')" />
            </div>
            <div class="line">
              <Key class="key-col-1 key-row-1" label="1" sublabel="↙" @keydown="keydown('Digit1')" @keyup="keyup('Digit1')" />
              <Key class="key-col-1 key-row-1" label="2" sublabel="↓" @keydown="keydown('Digit2')" @keyup="keyup('Digit2')" />
              <Key class="key-col-1 key-row-1" label="3" sublabel="↘" @keydown="keydown('Digit3')" @keyup="keyup('Digit3')" />
            </div>
            <div class="line">
              <Key class="key-col-2 key-row-1" label="0" sublabel="Y or RClick" @keydown="keydown('Digit0')" @keyup="keyup('Digit0')" />
              <Key class="key-col-1 key-row-1" label="Space" @keydown="keydown('Space')" @keyup="keyup('Space')" />
            </div>
          </div>
          <div class="col">
            <div class="line">
              <Key class="key-col-1 key-row-1" label="Back" @keydown="keydown('Backspace')" @keyup="keyup('Backspace')" />
            </div>
            <div class="line">
              <Key class="key-col-1 key-row-4" label="Enter" sublabel="N" @keydown="keydown('Enter')" @keyup="keyup('Enter')" />
            </div>
          </div>
        </div>
      </template>
    </div>

    <transition name="fade">
      <div class="message" v-if="message" v-html="message" />
    </transition>
  </div>
</template>
<script lang="ts">
import { Dropbox } from "dropbox";
import fileDialog from "file-dialog";
import { create } from "nipplejs";
import Vue from "vue";

import { createDos } from "../dos/create-dos";
import {
  blockAddEventListener,
  restoreAddEventListener,
  getBlockedHandler,
  createKeyboardEvent,
  EventHandler,
} from "../event";
import {
  createIdbFileSystem,
  IdbFileSystem,
} from "../fs/create-idb-file-system";
import { detectFileChange } from "../fs/detect-file-change";
import Key from "./key.vue";

const JOYSTICK_MAPS = [
  "ArrowRightUp",
  "ArrowUp",
  "ArrowLeftUp",
  "ArrowLeft",
  "ArrowLeftDown",
  "ArrowDown",
  "ArrowRightDown",
  "ArrowRight",
];

const KEY_MAPS: Record<string, number> = {
  Digit0: 48,
  Digit1: 49,
  Digit2: 50,
  Digit3: 51,
  Digit4: 52,
  Digit5: 53,
  Digit6: 54,
  Digit7: 55,
  Digit8: 56,
  Digit9: 57,

  Numpad0: 96,
  Numpad1: 97,
  Numpad2: 98,
  Numpad3: 99,
  Numpad4: 100,
  Numpad5: 101,
  Numpad6: 102,
  Numpad7: 103,
  Numpad8: 104,
  Numpad9: 105,

  NumpadAdd: 107,
  NumpadSubtract: 109,
  NumpadMultiply: 106,
  NumpadDivide: 111,
  NumpadEqual: 187,
  NumpadEnter: 13,
  NumpadDecimal: 110,

  PageUp: 33,
  PageDown: 34,
  Slash: 191,
  Period: 190,

  Enter: 13,
  Space: 32,

  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,

  Escape: 27,
  Backspace: 8,

  KeyA: 65, KeyB: 66, KeyC: 67, KeyD: 68, KeyE: 69,
  KeyF: 70, KeyG: 71, KeyH: 72, KeyI: 73, KeyJ: 74,
  KeyK: 75, KeyL: 76, KeyM: 77, KeyN: 78, KeyO: 79,
  KeyP: 80, KeyQ: 81, KeyR: 82, KeyS: 83, KeyT: 84,
  KeyU: 85, KeyV: 86, KeyW: 87, KeyX: 88, KeyY: 89, KeyZ: 90,

  ArrowLeftDown: 97,
  ArrowRightDown: 99,
  ArrowLeftUp: 103,
  ArrowRightUp: 105,
};

export default Vue.extend({
  components: { Key },
  props: {
    mod: { type: String, default: "sam2_kor" },
    entry: { type: String, default: "RTK2.COM" },
    save: { type: Array, default: ["1"] },
    dbx: { type: Object, default: null },
    isSingleGameMode: { type: Boolean, default: false },
  },
  data() {
    return {
      $database: null as IdbFileSystem | null,
      width: 640,
      height: 480,
      enabledToggleFullscreen: false,
      enabledToggleKeyboard: true,
      isClearExit: false,
      messageSt: null as any,
      message: null as string | null,
      keydownHandlers: [] as EventHandler[],
      keyupHandlers: [] as EventHandler[],
      joystickCode: null as string | null,
      pointX: 320,
      pointY: 240,
      pointMovement: 10,
      controllerMode: "keyboard" as "keyboard" | "mouse",
      joystickInstance: null as any,
      joystickInterval: null as any,
      mouseSpeed: 10,
      dpadInterval: null as any,
      activeDpadDir: null as string | null,
      dpadRect: null as DOMRect | null,
    };
  },
  async mounted() {
    this.controllerMode = (this.mod === "sam4pk" || this.mod === "hero") ? "mouse" : "keyboard";

    window.addEventListener("resize", this.onResize);
    this.onResize();

    const canvas = this.$refs.canvas as HTMLCanvasElement;
    const screen = this.$refs.screen as HTMLElement;

    if (this.mod == "sam4pk" || this.mod == "hero") {
      canvas.addEventListener("mousemove", (event) => {
        if (!event.isTrusted) return; // dispatchEvent로 발생한 가상 마우스 이동은 무시
        const rect = canvas.getBoundingClientRect();
        const rx = rect.width > 0 ? ((event.clientX - rect.left) / rect.width) : 0;
        const ry = rect.height > 0 ? ((event.clientY - rect.top) / rect.height) : 0;
        this.pointX = Math.max(0, Math.min(this.width, rx * this.width));
        this.pointY = Math.max(0, Math.min(this.height, ry * this.height));
      });
    }

    blockAddEventListener(document, ["keydown", "keyup", "keypress"]);

    const db = (this.$database = await createIdbFileSystem(this.mod, 1));
    const { fs, main } = await createDos(canvas);

    await fs.extract(`static/${this.mod}.zip`);

    for (const file of this.save) {
      const saveFileBody = await db.load<Uint8Array>(file);
      if (saveFileBody) {
        console.log("saveFileBody : " + file);
        (fs as any).fs.writeFile(file, saveFileBody);
      }
    }

    await main(["-c", this.entry]);

    this.keydownHandlers = getBlockedHandler(document, "keydown");
    this.keyupHandlers = getBlockedHandler(document, "keyup");

    restoreAddEventListener(document);

    document.addEventListener("keydown", this.onKeydown);
    document.addEventListener("keyup", this.onKeyup);

    // D-Pad 방식 사용 - 조이스틱 자동 초기화 불필요

    detectFileChange(fs, this.save, (file) => {
      db.save(file, (fs as any).fs.readFile(file));
      this.toastMessage(
        "세이브 파일이 브라우저에 저장되었습니다. [" + file + "]",
        1000
      );
      this.isClearExit = true;
      setTimeout(() => {
        this.isClearExit = false;
      }, 5000);
    });

    window.addEventListener("beforeunload", this.onBeforeUnload);
    document.addEventListener("fullscreenchange", this.onFullScreenChange);

    document.title = "三國志";
  },
  beforeDestroy() {
    this.destroyJoystick();
    this.dpadEnd();
    document.removeEventListener("keydown", this.onKeydown);
    document.removeEventListener("keyup", this.onKeyup);
    document.removeEventListener("fullscreenchange", this.onFullScreenChange);
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    window.removeEventListener("resize", this.onResize);
  },
  watch: {},
  methods: {
    onResize() {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      var keyWidth = 60;
      var keyHeight = 55;

      if (screenWidth >= screenHeight) {
        // 가로 모드: 키패드 너비(최대 320px, 최소 200px)를 먼저 분할 계산
        var keyboardWidth = screenWidth - (screenHeight * 640 / 480);
        if (keyboardWidth > 320) keyboardWidth = 320;
        if (keyboardWidth < 200) keyboardWidth = 200;

        // 게임 화면의 가용한 최대 너비 = 전체 너비 - 키패드 너비
        var maxGameWidth = screenWidth - keyboardWidth;
        
        // 4:3 비율을 유지하면서 maxGameWidth와 screenHeight 내에 맞춰 크기 결정
        var w = maxGameWidth;
        var h = (w * 480) / 640;
        if (h > screenHeight) {
          h = screenHeight;
          w = (h * 640) / 480;
        }
        this.width = ~~w;
        this.height = ~~h;

        keyWidth = (keyboardWidth - 12) / 4.25;
        keyHeight = (screenHeight - 66) / 5.3;
        keyHeight = Math.max(42, keyHeight);
      } else {
        // 세로 모드: 기존 비율 배분 적용
        if (screenWidth / 640 > screenHeight / 480) {
          this.width = ~~((screenHeight * 640) / 480);
          this.height = screenHeight;
        } else {
          this.width = screenWidth;
          this.height = ~~((screenWidth * 480) / 640);
        }

        keyWidth = screenWidth / 4.2;
        keyHeight = (screenHeight - this.height - 96) / 5.35;
        keyHeight = Math.max(45, keyHeight); // 최소 높이 보장
      }


      var span_gamewidth = document.getElementById("gamewidth");
      var span_gameheight = document.getElementById("gameheight");
      var span_screenwidth = document.getElementById("screenwidth");
      var span_screenheight = document.getElementById("screenheight");

      if (span_gamewidth) span_gamewidth.innerHTML = Math.floor(this.width).toString();
      if (span_gameheight) span_gameheight.innerHTML = Math.floor(this.height).toString();
      if (span_screenwidth) span_screenwidth.innerHTML = Math.floor(screenWidth).toString();
      if (span_screenheight) span_screenheight.innerHTML = Math.floor(screenHeight).toString();

      var ScreenSize = document.getElementById("ScreenSize");
      if (ScreenSize) ScreenSize.style.display = "none";

      this.pointX = Math.floor(this.width / 2);
      this.pointY = Math.floor(this.height / 2);
      this.pointMovement = Math.floor(this.pointX / 50);

      document.querySelectorAll<HTMLElement>(".key-col-1").forEach(k => k.style.width = keyWidth + "px");
      document.querySelectorAll<HTMLElement>(".key-col-2").forEach(k => k.style.width = keyWidth * 2 + 4 + "px");
      document.querySelectorAll<HTMLElement>(".key-col-3").forEach(k => k.style.width = keyWidth * 3 + 8 + "px");
      document.querySelectorAll<HTMLElement>(".key-row-1").forEach(k => k.style.height = keyHeight + "px");
      document.querySelectorAll<HTMLElement>(".key-row-2").forEach(k => k.style.height = keyHeight * 2 + 4 + "px");
      document.querySelectorAll<HTMLElement>(".key-row-3").forEach(k => k.style.height = keyHeight * 3 + 8 + "px");
      document.querySelectorAll<HTMLElement>(".key-row-4").forEach(k => k.style.height = keyHeight * 4 + 12 + "px");
    },
    onFullScreenChange() {
      this.enabledToggleFullscreen = !!window.document.fullscreenElement;
    },
    onBeforeUnload(e: BeforeUnloadEvent) {
      if (this.isClearExit) return;
      e.preventDefault();
      return (e.returnValue = "페이지를 벗어나면 저장하지 않은 내용이 날아갈 수 있습니다.");
    },
    onKeydown(e: KeyboardEvent) {
      var e_code = e.code;
      if (this.mod == "sam3" || this.mod == "khan3") {
        e_code = e_code.replace("Numpad", "Digit");
        if (e_code == "DigitEnter") e_code = "Enter";
      }
      this.keydown(e_code);
    },
    onKeyup(e: KeyboardEvent) {
      var e_code = e.code;
      if (this.mod == "sam3" || this.mod == "khan3") {
        e_code = e_code.replace("Numpad", "Digit");
        if (e_code == "DigitEnter") e_code = "Enter";
      }
      this.keyup(e_code);
    },
    toastMessage(message: string, timeout = 3000) {
      this.message = message;
      if (this.messageSt) clearTimeout(this.messageSt);
      this.messageSt = setTimeout(() => {
        this.message = null;
        this.messageSt = null;
      }, timeout);
    },
    toggleFullScreen() {
      const doc = window.document;
      if (!doc.fullscreenElement) {
        doc.documentElement.requestFullscreen();
      } else {
        doc.exitFullscreen();
      }
    },
    toggleKeyboard() {
      this.enabledToggleKeyboard = !this.enabledToggleKeyboard;
    },
    gotoHome() {
      location.href = "/";
    },
    async downloadSaveFile() {
      if (!this.$database) return;
      for (const file of this.save) {
        const data = await this.$database.load<Uint8Array>(file);
        if (data) {
          const url = URL.createObjectURL(new Blob([data], { type: "application/octet-stream" }));
          const a = document.createElement("a");
          a.href = url;
          a.download = file as string;
          a.style.display = "none";
          document.body.append(a);
          a.click();
          this.$nextTick(() => a.remove());
        }
      }
    },
    async uploadSaveFile() {
      if (!this.$database) return;
      const files = await fileDialog({ multiple: true });
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const data = new Uint8Array(await file.arrayBuffer());
        await this.$database.save(file.name, data);
        this.toastMessage("세이브 파일이 불러와졌습니다. [" + file.name + "]");
      }
    },
    keydown(code: string) {
      const keyCode = KEY_MAPS[code];
      if (keyCode === undefined) return;
      for (const handler of this.keydownHandlers) {
        handler(createKeyboardEvent("keydown", keyCode));
      }
    },
    keyup(code: string) {
      const keyCode = KEY_MAPS[code];
      if (keyCode === undefined) return;
      for (const handler of this.keyupHandlers) {
        handler(createKeyboardEvent("keyup", keyCode));
      }
    },
    getCanvasClientCoords(x: number, y: number) {
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return { x: 0, y: 0 };
      const rect = canvas.getBoundingClientRect();
      const rx = this.width > 0 ? (x / this.width) : 0;
      const ry = this.height > 0 ? (y / this.height) : 0;
      this.rxValue = rx;
      this.ryValue = ry;
      return {
        x: rect.left + rx * rect.width,
        y: rect.top + ry * rect.height,
      };
    },
    MoveMouse(x: number, y: number) {
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return;
      const coords = this.getCanvasClientCoords(x, y);
      const event = new MouseEvent("mousemove", {
        bubbles: true,
        cancelable: true,
        view: window,
        clientX: coords.x,
        clientY: coords.y,
      });
      canvas.dispatchEvent(event);
    },
    onMouseLeftDown(e: TouchEvent) {
      if (e.cancelable) {
        e.preventDefault();
      }
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return;
      const coords = this.getCanvasClientCoords(this.pointX, this.pointY);
      canvas.dispatchEvent(new MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 0,
        clientX: coords.x,
        clientY: coords.y,
      }));
    },
    onMouseLeftUp(e: TouchEvent) {
      if (e.cancelable) {
        e.preventDefault();
      }
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return;
      const coords = this.getCanvasClientCoords(this.pointX, this.pointY);
      canvas.dispatchEvent(new MouseEvent("mouseup", {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 0,
        clientX: coords.x,
        clientY: coords.y,
      }));
    },
    onMouseRightDown(e: TouchEvent) {
      if (e.cancelable) {
        e.preventDefault();
      }
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return;
      const coords = this.getCanvasClientCoords(this.pointX, this.pointY);
      canvas.dispatchEvent(new MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 2,
        clientX: coords.x,
        clientY: coords.y,
      }));
    },
    onMouseRightUp(e: TouchEvent) {
      if (e.cancelable) {
        e.preventDefault();
      }
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      if (!canvas) return;
      const coords = this.getCanvasClientCoords(this.pointX, this.pointY);
      canvas.dispatchEvent(new MouseEvent("mouseup", {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 2,
        clientX: coords.x,
        clientY: coords.y,
      }));
    },
    selectControllerMode(mode: "keyboard" | "mouse") {
      this.controllerMode = mode;
      this.$nextTick(() => { this.onResize(); });
    },
    destroyJoystick() {
      if (this.joystickInterval) {
        clearInterval(this.joystickInterval);
        this.joystickInterval = null;
      }
      if (this.joystickInstance) {
        this.joystickInstance.destroy();
        this.joystickInstance = null;
      }
    },
    dpadStart(dir: string) {
      this.dpadEnd();
      this.activeDpadDir = dir;
      const step = this.mouseSpeed;
      const diagStep = Math.round(step * 0.707);
      const moves: Record<string, [number, number]> = {
        up:        [0, -step],
        down:      [0,  step],
        left:      [-step, 0],
        right:     [step, 0],
        upleft:    [-diagStep, -diagStep],
        upright:   [diagStep, -diagStep],
        downleft:  [-diagStep, diagStep],
        downright: [diagStep, diagStep],
      };
      const [dx, dy] = moves[dir] || [0, 0];
      const move = () => {
        this.pointX = Math.max(0, Math.min(this.width,  this.pointX + dx));
        this.pointY = Math.max(0, Math.min(this.height, this.pointY + dy));
        this.MoveMouse(this.pointX, this.pointY);
      };
      move();
      this.dpadInterval = setInterval(move, 50);
    },
    dpadEnd(dir?: string) {
      if (dir && this.activeDpadDir !== dir) {
        return; // 다른 키가 눌린 이후면 이전 누름 해제 이벤트 무시
      }
      if (this.dpadInterval) {
        clearInterval(this.dpadInterval);
        this.dpadInterval = null;
      }
      this.activeDpadDir = null;
    },
    onDpadTouchStart(e: TouchEvent) {
      const container = e.currentTarget as HTMLElement;
      this.dpadRect = container.getBoundingClientRect();
      if (e.touches.length > 0) {
        this.handleDpadTouch(e.touches[0]);
      }
    },
    onDpadTouchMove(e: TouchEvent) {
      if (e.touches.length > 0) {
        this.handleDpadTouch(e.touches[0]);
      }
    },
    onDpadTouchEnd() {
      this.dpadEnd();
    },
    handleDpadTouch(touch: Touch) {
      if (!this.dpadRect) return;
      const centerX = this.dpadRect.left + this.dpadRect.width / 2;
      const centerY = this.dpadRect.top + this.dpadRect.height / 2;
      const dx = touch.clientX - centerX;
      const dy = touch.clientY - centerY;
      const dist = Math.sqrt(dx * dx + dy * dy);

      // 데드존 (가운데 좌클릭 영역 반경은 약 37px)
      if (dist < 37) {
        if (this.activeDpadDir) {
          this.dpadEnd();
        }
        return;
      }

      // 수학적 각도 연산 (0 ~ 360도)
      let angle = Math.atan2(dy, dx);
      let deg = angle * 180 / Math.PI;
      if (deg < 0) deg += 360;

      // 8분면 매핑 (오른쪽 0도를 기준으로 시계방향 45도씩 분할)
      let normalizedDeg = (deg + 22.5) % 360;
      let octant = Math.floor(normalizedDeg / 45);
      const dirs = ["right", "downright", "down", "downleft", "left", "upleft", "up", "upright"];
      const dir = dirs[octant];

      if (dir && this.activeDpadDir !== dir) {
        this.dpadStart(dir);
      }
    },
  },
});
</script>